// ./src/utils/eventFeatureRules.ts
//
// THE FEATURES AN EVENT ACTUALLY HAS: the host's ticks run through the seeded setup rules (ROADMAP A2b #62 / #63). A
// feature the mode cannot have is dropped, one it requires is kept — a ticketed event has Tickets whatever was ticked.
//
// ⚠⚠ ONE FUNCTION, THREE READERS, so none can disagree with another about the same event:
//   - the wizard's Features step and the Event features page SAVE through it;
//   - `CurrentEventContext` runs it over what is STORED before the menu reads it. Details & Settings can change how
//     guests join without touching `settings.features`, so the stored list can lag the mode — an RSVP event switched
//     to tickets would otherwise have its selling pages tucked behind "Show more" while the Features page calls Tickets
//     "always on" (found in review, 2026-09-29).
// ⚠ A null mode is read as the product's default one (Details & Settings does the same), never as "no mode": with
//   null, every mode-conditioned rule would be skipped and a list the displayed mode forbids could be saved.
// ⚠ Pure — `npm run check-event-setup` runs it on fixtures.
import type { EventSetupType } from '@/utils/api/EventSetupService';
import { evaluateSetupRules } from '@/config/eventSetup.generated';
import type { EventSetupRule } from '@/config/eventSetup.generated';
import { DEFAULT_GUEST_MODE } from '@/components/features/Events/controls/guestModeConfig';

export const featuresAfterRules = (
  type: EventSetupType | null,
  parent: EventSetupType | null,
  rules: readonly EventSetupRule[],
  eventMode: string | null,
  ticked: readonly string[],
): string[] =>
  evaluateSetupRules(rules, {
    eventMode: eventMode ?? DEFAULT_GUEST_MODE,
    categoryCode: type?.code ?? null,
    parentCategoryCode: parent?.code ?? null,
    categoryGroup: parent?.categoryGroup ?? type?.categoryGroup ?? null,
    featuresOn: [...ticked],
    spaceId: null,
  }).on;
